module.exports = __webpack_public_path__ + "vue-app/img/small-3.f7605607.jpg";